import { useEffect } from 'react';
import { ControlPosition, useControl, Map } from 'shared/map-exports';

import { useTranslation } from 'react-i18next';
import { MapControlButton, useButtonGroupStyles } from './MapControlButton';
import BaseMapboxGLController from './BaseMapboxGLController';
import { MapViewDimension } from '../constants';

type MapViewDimensionControlProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  position?: ControlPosition;
  // eslint-disable-next-line react/no-unused-prop-types
  setMapViewDimension: (viewDimension: MapViewDimension) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  mapViewDimension: MapViewDimension;
};

const MapViewDimensionControlContent = (
  props: MapViewDimensionControlProps,
): JSX.Element => {
  const { t } = useTranslation();

  const { mapViewDimension, setMapViewDimension } = props;

  const handleToggleBaseMapViewDimension = (): void => {
    //   /*
    //   TODO: 3D Map
    //   FirebaseAnalytics.logEvent({
    //     name: `${ANALYTICS_EVENTS.CLICKED.BASE_MAP_LAYER_CHANGE}_${layer}`,
    //     params: {},
    //   });
    //   FirebaseAnalytics.logEvent({
    //     name: ANALYTICS_EVENTS.CLICKED.BASE_MAP_LAYER_CHANGE,
    //     params: { layer },
    //   });
    //   */
    setMapViewDimension(
      mapViewDimension === MapViewDimension['3D']
        ? MapViewDimension['2D']
        : MapViewDimension['3D'],
    );
  };

  const buttonText =
    mapViewDimension === MapViewDimension['3D']
      ? t('map.layers.dimensions.2D')
      : t('map.layers.dimensions.3D');

  const { classes } = useButtonGroupStyles();
  return (
    <MapControlButton
      onClick={() => handleToggleBaseMapViewDimension()}
      text={buttonText}
      className={classes.groupBottomButton}
      size="small"
    />
  );
};

class MapboxGLMapTypeController extends BaseMapboxGLController<
  MapViewDimensionControlProps & { map?: Map }
> {
  content = (): JSX.Element => (
    <MapViewDimensionControlContent map={this.map} {...this.props} />
  );
}

const MapViewDimensionControl = (props: MapViewDimensionControlProps): null => {
  const { position } = props;
  // @ts-ignore - https://github.com/visgl/deck.gl/issues/9211
  const controller = useControl(() => new MapboxGLMapTypeController(props), {
    position,
  }) as MapboxGLMapTypeController;

  controller.update(props);
  useEffect(() => controller.render(), [controller, props]);
  return null;
};

export default MapViewDimensionControl;
